import { changeNumberApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const getChangeMobileCardProfileDetails = (payload) => {
  const url = changeNumberApi.DIST_CARD_PROFILE_CHANGE_NUMBER;
  return axios.post(url, payload);
};

export const getChangeExistingServiceNumber = (payload) => {
  const url = changeNumberApi.EXISTING_SERVICE_NUMBER_CHANGE;
  return axios.post(url, payload);
};
